import { styled } from '@mui/system';
import { Stack } from '@mui/material';

export const TitleWithSubtitleContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
}));
